import React, {useMemo} from 'react'
import styles from './ResourceCardStats.module.scss'
import {useUIGameEndContext} from '../../../../../contexts/UIGameEndContext'
import {BarChart} from '../../BarChart'
import {CardDataController} from '@colonist/game-card-types'
import {CardEnum} from '@colonist/game-states'
import {UIGameCard} from '../../../../../common/UIGameCard'
import {T} from '../../../../../common/T'
import {useGameStore} from '../../../../../store/GameStoreContext'

export const ResourceCardStats = () => {
    const {gameEndData} = useUIGameEndContext()
    const activeResourceCardTypes = useGameStore((state) => state.gameMode.activeResourceCardTypes)
    const activeResourceCards = CardDataController.getCardEnumsOfTypes(activeResourceCardTypes)
    const resourceCardsCountMap = useMemo(() => {
        const countMap: {[key in CardEnum]?: number} = {}

        gameEndData.endGameState.resourceCardsStats.forEach((num) => {
            if(countMap[num] === undefined) {
                countMap[num] = 0
            }
            countMap[num] += 1
        })

        return countMap
    }, [gameEndData])

    const chartData = useMemo(() => activeResourceCards.map((cardId) => ({
        label: <UIGameCard
            cardEnum={cardId}
            className={styles.card}
            showTipTitle
        />,
        value: resourceCardsCountMap[cardId] ?? 0,
    }
    )), [activeResourceCards, resourceCardsCountMap])

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <T id={{key: 'strings:game.endGame.resourceCards.cardsDrawn'}}/>
            </div>
            <BarChart chartData={chartData}/>
        </div>
    )
}
